import {
  AccountBookOutlined,
  AimOutlined,
  BarsOutlined,
  EditOutlined,
  FileImageOutlined,
  FileTextOutlined,
  QrcodeOutlined,
  SyncOutlined,
  TeamOutlined,
  CopyOutlined
} from "@ant-design/icons";
import {
  Button,
  Card,
  Descriptions,
  Divider,
  Empty,
  Image as AntImage,
  Menu,
  message,
  Modal,
  Skeleton,
  Space,
  Tag,
} from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import dayjs from "dayjs";
import React, { useMemo } from "react";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import LocationViewer from "./location/location";
import {
  isComplate,
  Location,
  Picture,
  PictureNames,
  ServeBrief,
  ServeEvent,
  ServeModes,
  ServeTypes,
  ServiceDetails,
  ServiceItems,
  ServiceRelated,
} from "../../../constants/serve";
import { OSS } from "../../../requestor/oss";
import * as ItemsRenderer from "./items";
import LocationsRenderer from "./location";
import Bill from "./common/bill";
import Requestor from "../../../requestor"
import review from "../../../assets/review.png"
import unreview from "../../../assets/unreview.png"

function copy(text: string | undefined) {
  if (!text) return;
  let textArea: HTMLTextAreaElement | null = document.getElementById('copytextArea') as HTMLTextAreaElement
  if (textArea) {
    textArea = textArea as HTMLTextAreaElement
    textArea.innerText = text
    textArea.value = text
    textArea.setAttribute("value", text)
    textArea.select()
    textArea.setSelectionRange(0, text.length)
    let res = document.execCommand('copy')
    if (res) {
      message.success("复制成功")
    }
  }
}


type IProps = { sid?: string, goBack?: () => void };

const ServeDetails: React.FC<IProps> = (props: IProps) => {
  const { sid: _sid } = useParams();
  const Navigate = useNavigate();
  const [preview, updatePrivew] = React.useState({ visible: false, index: 0 });
  const [brief, updateBrief] = React.useState<ServeBrief | null>(null);
  const [events, updateEvents] = React.useState<ServeEvent[] | null>(null);
  const [locations, updateLocations] = React.useState<Location[] | null>(null);
  const [parts, updateParts] = React.useState<ServiceRelated | null>(null);
  const [items, updateItems] = React.useState<ServiceItems | null>(null);
  const [pictures, updatePictures] = React.useState<Picture[] | null>(null);
  const [showQr, setShowQr] = React.useState(false);
  const [showBill, setShowBill] = React.useState(false);

  const [fixer, updateFixer] = React.useState<number>(-1);//0客户信息 1 2叫车人 3服务人 4添加备注 5查看备注 6报案号
  // const starting = locations?.find((l) => l.type === 0);
  // const destination = locations?.find((l) => l.type === 1);

  const sid = useMemo(() => {
    if (_sid) {
      return _sid
    }
    else {
      return props.sid
    }
  }, [_sid, props.sid])

  // 已支付或者已挂帐
  const paid = React.useMemo(() => {
    if (brief === null || brief === undefined) {
      return false;
    }

    // 只要是已支付或者已经挂过帐 都不能删除
    return brief.payStatus === 1 || brief.creditStatus === 1
    // return brief.paymentStatus > 0;
  }, [brief]);

  const [onViewLocation, setOnViewLocation] = React.useState<
    { latitude: number; longitude: number } | undefined
  >();

  const remarkMenu = (
    <Menu
      items={[
        {
          key: "1",
          label: "添加备注",
          icon: <EditOutlined />,
          onClick: () => updateFixer(4),
        },
        {
          key: "2",
          label: "查看备注",
          icon: <FileTextOutlined />,
          onClick: () => updateFixer(5),
        },
      ]}
    />
  );

  const pics = React.useMemo(() => {
    if (pictures == null) {
      return;
    }

    return pictures.map((pic: Picture, idx: number) => {
      return {
        idx,
        oid: pic.oid,
        matter: pic.matter,
        label: PictureNames[pic.matter],
        url: OSS.redirectToImage(pic.oid),
      };
    });
  }, [pictures]);

  const hasNoItems = React.useMemo(() => {
    if (items == null) {
      return true;
    }
    for (let k in items) {
      if (Object.getOwnPropertyDescriptor(items, k) !== undefined) {
        return false;
      }
    }

    return true;
  }, [items]);

  const totalFee = React.useMemo(() => {
    if (items == null) {
      return 0;
    }

    const { basement, crane, crane1, electrify, hs, oil, sr, tyre, wheel, vt, dilemmaRescue, other } =
      items;

    let totalFee = 0;
    if (vt) {
      vt.map((v) => (totalFee += v.totalFee));
    }

    totalFee += basement ? basement.totalFee : 0;
    totalFee += crane ? crane.totalFee : 0;
    totalFee += crane1 ? crane1.totalFee : 0;
    totalFee += electrify ? electrify.totalFee : 0;
    totalFee += hs ? hs.totalFee : 0;
    totalFee += oil ? oil.totalFee : 0;
    totalFee += sr ? sr.totalFee : 0;
    totalFee += tyre ? tyre.totalFee : 0;
    totalFee += wheel ? wheel.totalFee : 0;
    totalFee += dilemmaRescue ? dilemmaRescue.totalFee : 0;
    totalFee += other ? other.totalFee : 0;

    return totalFee;
  }, [items]);

  const itemsEmpty = React.useMemo(() => {
    if (items == null) {
      return true;
    }

    const { basement, crane, crane1, electrify, hs, oil, sr, tyre, wheel, vt } =
      items;

    return (
      basement === undefined &&
      crane === undefined &&
      crane1 === undefined &&
      electrify === undefined &&
      hs === undefined &&
      oil === undefined &&
      sr === undefined &&
      tyre === undefined &&
      wheel === undefined &&
      (vt === undefined || vt.length === 0)
    );
  }, [items]);

  const getBrief = React.useCallback(() => {
    Requestor.getServiceDetails<ServiceDetails>(`${sid}`)
      .then((res) => {
        if (res.error !== "") {
          throw new Error(res.error);
        }
        if (res.result.brief === null) {
          throw new Error("没有查询到详情信息");
        }
        const { result } = res;
        updateBrief(result.brief);
        updateEvents(result.events.sort((b, a) => b.timestamp - a.timestamp));
        updateParts(result.participants);
        updateItems(result.items);
        updateLocations(result.locations);
        updatePictures(result.pictures);
      })
      .catch((e) => {
        message.error("查询失败:" + e)
        console.log(e);
      });
  }, []);

  React.useEffect(() => {
    getBrief()
  }, [Requestor, sid]);

  return (
    <div className="flex flex-column">
      <div className="background-color-f0f0f0">
        <PageHeader
          onBack={() => {
            props.goBack ? props.goBack() : Navigate(-1);
          }}
          title="服务详情"
          tags={[
            <Tag key="serve_mode" color={"blue"}>
              {ServeModes[brief ? brief.mode : 0]}
            </Tag>,
            <Tag key="serve_type" color="green">
              {ServeTypes[brief ? brief.type : 0]}
            </Tag>,
          ]}
          ghost
        >
          <div className="flex">
            <div className="flex-1">
              <Space>
                {[
                  <Button
                    icon={<QrcodeOutlined />}
                    type="primary"
                    key="qrCode"
                    onClick={() => setShowQr(true)}
                  >
                    服务二维码
                  </Button>,
                  brief && <Button
                    type="primary"
                    key="totalFee"
                    icon={<AccountBookOutlined />}
                    onClick={() => { if (totalFee > 0) { setShowBill(true) } else { message.warning("暂无账单信息") } }}
                  >
                    账单（ ¥{totalFee / 100}）
                  </Button>,
                  <Button
                    key="ref--"
                    type="dashed"
                    icon={<SyncOutlined />}
                    onClick={() => getBrief()}
                  >
                    刷新
                  </Button>
                ]}</Space>
            </div>
            {brief ? <div style={{ position: "absolute", right: '60px', top: "-10px" }}>
              <img src={brief.feedback === true ? review : unreview} alt="" style={{ width: "180px" }} />
            </div> : ''}
          </div>

          <Divider />
          <Skeleton loading={brief === null} active>
            <Descriptions column={4}>
              <Descriptions.Item label="车牌号码">
                {brief?.client.license} {brief?.client.license && <Button size="small" type="link" icon={<CopyOutlined />} onClick={() => copy(brief?.client.license)}></Button>}
              </Descriptions.Item>
              <Descriptions.Item label="车辆信息">
                {brief?.client.brand} {brief?.client.color}{" "}
                {
                  ["小型车", "中型车", "中大型车"][brief ? brief.client.size : 0]
                }
              </Descriptions.Item>
              <Descriptions.Item label="客户称呼">
                {brief?.client.name}{" "}
                {["", "先生", "女士"][brief ? brief.client.gender : 0]}
              </Descriptions.Item>
              <Descriptions.Item label="客户电话">
                {brief?.client.phone}{brief?.client.phone && <Button size="small" type="link" icon={<CopyOutlined />} onClick={() => copy(brief?.client.phone)}></Button>}
              </Descriptions.Item>
              <Descriptions.Item label="报案号">
                {brief?.providerOutNo}{brief?.providerOutNo && <Button size="small" type="link" icon={<CopyOutlined />} onClick={() => copy(brief?.providerOutNo)}></Button>}
              </Descriptions.Item>
              <Descriptions.Item label="救援模式">
                {brief?.mode === 1 ? '非事故救援' : '事故救援'}
              </Descriptions.Item>
              <Descriptions.Item label="接车人姓名">
                {brief?.pickupName}
              </Descriptions.Item>
              <Descriptions.Item label="接车人电话">
                {brief?.pickupPhone}
              </Descriptions.Item>
              <Descriptions.Item label="调度时间">
                {dayjs(brief ? brief?.createdAt * 1000 : 0).format(
                  "YYYY-MM-DD HH:mm:ss"
                )}
              </Descriptions.Item>
              <Descriptions.Item label="支付状态">
                {brief && (isComplate(brief) ? <Tag color="green">已完成</Tag> : <Tag color="red">未完成</Tag>)}
              </Descriptions.Item>
              <Descriptions.Item label="服务状态">
                {brief?.statusText.includes("取消") ? <Tag color="#cd201f">{brief?.statusText}</Tag> : ''
                  //  brief?.statusText} {(events && brief) && <KeySteps sid={brief!.sid} events={events || []}></KeySteps>
                }
              </Descriptions.Item>
            </Descriptions>
          </Skeleton>
        </PageHeader>
      </div>
      <div>
        <Card
          className="margin-top-16px background-color-f6f6f6"
          title={
            <div className="flex">
              <AimOutlined className="font-color-1e90ff font-size-20px" />
              <span className="margin-left-16px">位置信息</span>
            </div>
          }
        >
          <Skeleton active loading={locations === null}>
            <div>
              <LocationsRenderer
                locations={locations ? locations : []}
                onRefresh={(nextLocations) => updateLocations(nextLocations)}
                onClick={(l: Location) => {
                  setOnViewLocation({
                    latitude: parseFloat(l.latitude),
                    longitude: parseFloat(l.longitude),
                  });
                }}
              />
            </div>
          </Skeleton>
        </Card>
        <Card
          className="margin-top-16px  background-color-f6f6f6"
          title={
            <div className="flex">
              <TeamOutlined className="font-color-1e90ff font-size-20px" />{" "}
              <span className="margin-left-16px">相关人信息</span>
            </div>
          }
        >
          <Skeleton active loading={parts === null}>
            <Descriptions column={3}>
              {/* <Descriptions.Item label="保险公司">
                {parts?.provider?.name}
              </Descriptions.Item> */}
              <Descriptions.Item label="查勘员">
                {parts?.surveyor?.name}
              </Descriptions.Item>
              <Descriptions.Item label="监督员">
                {parts?.providerInspector?.name}
              </Descriptions.Item>
              <Descriptions.Item label="调度公司">
                {parts?.dispatcherCompany?.name}
              </Descriptions.Item>
              <Descriptions.Item label="调度员">
                {parts?.dispatcher?.name}
              </Descriptions.Item>
              <Descriptions.Item label="拖车方">
                {parts?.driverCompany?.name}
              </Descriptions.Item>
              {/* <Descriptions.Item label="实施方驾驶员">
                {parts?.driver?.name}<span style={{ color: "#1890ff", padding: "0px 0.5rem" }}>{parts?.driver?.phone}</span>
              </Descriptions.Item>
              <Descriptions.Item label="实施方监督员">
                {parts?.driverInspector?.name}
              </Descriptions.Item> */}
            </Descriptions>
          </Skeleton>
        </Card>
        <Card
          className="margin-top-16px  background-color-f6f6f6"
          title={
            <div className="flex" style={{ verticalAlign: "middle" }}>
              <BarsOutlined className="font-color-1e90ff font-size-20px" style={{ verticalAlign: "middle" }} />{" "}
              <span className="margin-left-16px">服务项目</span>
            </div>
          }
        >
          <Skeleton active loading={items === null}>
            {hasNoItems ? <Empty description="没有服务项" /> : null}
            <ItemsRenderer.VT
              vts={items?.vt}
              locations={locations}
            />
            <ItemsRenderer.Crane
              crane={items?.crane}
              locations={locations}
            />
            <ItemsRenderer.Crane1
              crane1={items?.crane1}
              locations={locations}
            />
            <ItemsRenderer.Basement
              basement={items?.basement}
            />
            <ItemsRenderer.SR
              sr={items?.sr}
            />
            <ItemsRenderer.Wheel
              wheel={items?.wheel}
            />
            <ItemsRenderer.Oil
              oil={items?.oil}
              locations={locations}
            />
            <ItemsRenderer.Electrify
              electrify={items?.electrify}
              locations={locations}
            />
            <ItemsRenderer.Trouble
              trouble={items?.dilemmaRescue}
              locations={locations}
            />
            <ItemsRenderer.Tyre tyre={items?.tyre} locations={locations} />
            <ItemsRenderer.OtherFee otherFee={items?.other} />
          </Skeleton>
        </Card>


        <Card
          className="margin-top-16px background-color-f6f6f6"
          title={
            <div className="flex">
              <FileImageOutlined className="font-color-1e90ff font-size-20px" />{" "}
              <span className="margin-left-16px">服务图片</span>
            </div>
          }
        >
          <Skeleton active loading={pictures === null}>
            <div className="width-100p overflow-scroll ">
              <div className="text-center">
                {pics?.map((p, pidx) => {
                  return (
                    <Image
                      idx={p.idx}
                      key={p.oid}
                      label={PictureNames[p.matter]}
                      onClick={(idx) => {
                        updatePrivew({ visible: true, index: idx });
                      }}
                      deleteImage={() => {
                        // deleteImage(sid!, p.oid, p.matter);
                      }}
                      url={`${OSS.redirectToImage(
                        p.oid
                      )}?x-oss-process=image/resize,m_lfit,h_436,w_500`}
                    />
                  );
                })}
              </div>
            </div>
            <div style={{ display: "none" }}>
              <AntImage.PreviewGroup
                preview={{
                  current: preview.index,
                  visible: preview.visible,
                  onChange: (current: number) => {
                    updatePrivew({ index: current, visible: true })
                  },
                  onVisibleChange: (vis: boolean) =>
                    updatePrivew({ index: 0, visible: vis }),
                }}
              >
                {pics?.map((p) => (
                  <AntImage src={p.url} key={p.oid} />
                ))}
              </AntImage.PreviewGroup>
            </div>
          </Skeleton>
        </Card>
      </div>
      <input id="copytextArea" style={{ opacity: 0 }} />
      <Modal
        title="二维码"
        open={showQr}
        footer={null}
        onCancel={() => setShowQr(false)}
      >
        <div className="flex flex-center">
          <QRCode
            ecLevel="L"
            style={{ display: brief ? "block" : "none" }}
            size={300}
            fgColor="#1890ff"
            value={`{"type":"sid", "sid":"${brief?.sid}"}`}
          />
        </div>
      </Modal>
      {/* 
      <Modal
        open={fixer > -1}
        title={fixers[fixer]?.title}
        footer={null}
        width={[undefined, 1024, 1200, 1200][fixer]}
        onCancel={() => updateFixer(-1)}
      >
        <FixerComp />
      </Modal>
 */}
      <Modal
        open={onViewLocation !== undefined}
        title="位置"
        width={720}
        footer={null}
        destroyOnClose
        onCancel={() => setOnViewLocation(undefined)}
      >
        <LocationViewer
          longitude={onViewLocation?.longitude}
          latitude={onViewLocation?.latitude}
        />
      </Modal>



      <Modal
        title=""
        width={1024}
        open={showBill}
        footer={null}
        style={{ top: 24 }}
        onCancel={() => setShowBill(false)}
        destroyOnClose
        maskClosable={false}
      >
        {brief && <Bill
          sid={brief.sid}
          onComplete={() => {
          }}
        />}
      </Modal>
    </div>
  );
};

type ImageProos = {
  idx: number;
  label: string;
  url: string;
  onClick: (idx: number) => void;
  deleteImage: () => void;
};

const Image: React.FC<ImageProos> = (props: ImageProos) => {
  const { url, label } = props;

  return (
    <div
      className="relative width-160px height-160px border-radius-8px"
      style={{
        display: "inline-block",
        margin: "4px",
        cursor: "pointer",
        overflow: "hidden",
      }}
    >
      <div
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); props.onClick(props.idx) }}
      >
        <img alt="" width={160} height={160} src={url} className="hover-zoom" style={{ objectFit: "cover" }} />
        <div
          className="absolute flex flex-center font-color-ffffff width-160px height-32px"
          style={{
            left: "0",
            bottom: "0",
            backgroundColor: "rgba(0,0,0,0.6)",
          }}
        >
          {label}
        </div>
      </div>

      {/* <div className="absolute" style={{ top: "-2px", right: "0px", zIndex: 10 }}>
        <Popconfirm placement="topLeft" title={`确定要删除“${label}”图片吗`} onConfirm={props.deleteImage} okText="删除" cancelText="点错了">
          <Tooltip title="删除图片">
            <Button size="small" type="default" shape="circle" icon={<DeleteOutlined />}></Button>
          </Tooltip>
        </Popconfirm>
      </div> */}
    </div>
  );
};

export default ServeDetails;
